import { TabsTrigger } from '@radix-ui/react-tabs'
import { ChevronRightIcon } from 'lucide-react'
import React from 'react'

import { type IconProp } from 'slab/types'

interface TabProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  children: React.ReactNode;
  filtersCount?: number;
  leftIcon?: IconProp;
  name: string;
}

export function Tab ({
  children,
  filtersCount,
  leftIcon: LeftIcon,
  name,
  ...props
}: TabProps) {
  return (
    <TabsTrigger
      {...props}
      className='py-0.5 px-2 group/category outline-none'
      value={name}
    >
      <div className='p-2 rounded-md bg-transparent flex gap-4 justify-between items-center body transition cursor-pointer text-gray-500 group-hover/category:text-gray-800 group-data-[state=active]/category:text-gray-800 group-hover/category:bg-gray-200 group-data-[state=active]/category:bg-gray-200 outline outline-2 outline-offset-2 outline-transparent group-focus-visible/category:outline-thatch-500'>
        <div className='flex items-center gap-2'>
          {!!LeftIcon && (
            <span className='text-gray-400 group-hover/category:text-gray-500 group-data-[state=active]/category:text-gray-500 transition'>
              <LeftIcon aria-hidden size={16} />
            </span>
          )}
          <span>
            {children}
            <span className='inline-block w-6'>
              {filtersCount
                ? (
                  `(${filtersCount})`
                  )
                : null}
            </span>
          </span>
        </div>
        <span className='text-gray-500 opacity-0 group-data-[state=active]/category:opacity-100 group-hover/category:opacity-100 transition'>
          <ChevronRightIcon aria-hidden size={16} />
        </span>
      </div>
    </TabsTrigger>
  )
}

Tab.displayName = 'FiltersDropdown.Tab'
